var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	45565: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	66897: () => (loadStrictSingletonVersion("default", "@angular/animations", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_animations_mjs-_d6a81").then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	45315: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_common_mjs-_b4621").then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	1975: () => (loadStrictSingletonVersion("default", "rxjs", false, [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	9218: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_platform_mjs-_90950").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	18606: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_layout_mjs-_77ce1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))))),
	18934: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion/private", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_coercion_private_mjs-_52b81").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion/private */ 22810))))))),
	42287: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [1,7,8,1], () => (__webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	57802: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_coercion_mjs-_bff60").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	73986: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	89636: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_mjs-_b1b11").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	70600: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_collections_mjs-_c5cc1").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))))),
	10766: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_bidi_mjs-_04d91").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	39866: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	48934: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_overlay_mjs-_40551").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	72374: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_portal_mjs-_b9700").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	38324: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b01").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))))),
	50747: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_signals_mjs").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	12027: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/event-dispatch", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_core_fesm2022_primitives_event-dispatch_mjs").then(() => (() => (__webpack_require__(/*! @angular/core/primitives/event-dispatch */ 56745))))))),
	43984: () => (loadStrictSingletonVersion("default", "@angular/material/core", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_core_mjs-_90eb1").then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))))),
	57463: () => (loadStrictSingletonVersion("default", "@angular/cdk", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_cdk_mjs-_2fb50").then(() => (() => (__webpack_require__(/*! @angular/cdk */ 31398))))))),
	96210: () => (loadStrictSingletonVersion("default", "@angular/cdk/dialog", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_dialog_mjs-_76f31").then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))))),
	53734: () => (loadStrictSingletonVersion("default", "@angular/cdk/accordion", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_accordion_mjs-_46101").then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))))),
	81663: () => (loadStrictSingletonVersion("default", "@angular/common/http", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_common_fesm2022_http_mjs-_f9341").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	21194: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	62528: () => (loadStrictSingletonVersion("default", "@angular/material/divider", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_material_fesm2022_divider_mjs-_593e0").then(() => (() => (__webpack_require__(/*! @angular/material/divider */ 14102))))))),
	93793: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1").then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	83440: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", false, [1,18,2,14], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2022_observers_private_mjs-_ae971").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))))),
	30099: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_animations_fesm2022_browser_mjs-_2a591").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	38445: () => (loadStrictSingletonVersion("default", "graphql", false, [1,16,9,0], () => (__webpack_require__.e("node_modules_graphql_index_mjs").then(() => (() => (__webpack_require__(/*! graphql */ 64198))))))),
	34953: () => (loadStrictSingletonVersion("default", "@azure/msal-browser", false, [1,4,14,0], () => (__webpack_require__.e("node_modules_azure_msal-browser_dist_index_mjs-_29931").then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ 74102))))))),
	13319: () => (loadStrictSingletonVersion("default", "@angular/router", false, [1,18,2,13], () => (__webpack_require__.e("node_modules_angular_router_fesm2022_router_mjs-_5a221").then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))))),
	95517: () => (loadStrictSingletonVersion("default", "@apollo/client/core", false, [1,3,12,3], () => (__webpack_require__.e("node_modules_apollo_client_core_index_js").then(() => (() => (__webpack_require__(/*! @apollo/client/core */ 22361)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a590": [
		45565,
		66897
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a80": [
		45315,
		45565
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca010": [
		1975,
		9218,
		18606,
		18934,
		42287,
		45315,
		45565,
		57802,
		73986,
		89636
	],
	"node_modules_angular_cdk_fesm2022_accordion_mjs-_46100": [
		1975,
		45565,
		70600
	],
	"node_modules_angular_cdk_fesm2022_bidi_mjs-_04d90": [
		45315,
		45565
	],
	"node_modules_angular_cdk_fesm2022_coercion_private_mjs-_52b80": [
		1975
	],
	"node_modules_angular_cdk_fesm2022_coercion_mjs-_bff61": [
		45565
	],
	"node_modules_angular_cdk_fesm2022_collections_mjs-_c5cc0": [
		1975,
		45565
	],
	"node_modules_angular_cdk_fesm2022_dialog_mjs-_76f30": [
		1975,
		9218,
		10766,
		39866,
		42287,
		45315,
		45565,
		48934,
		72374,
		73986
	],
	"node_modules_angular_cdk_fesm2022_layout_mjs-_77ce0": [
		1975,
		9218,
		42287,
		45565,
		57802
	],
	"node_modules_angular_cdk_fesm2022_observers_private_mjs-_ae970": [
		1975,
		42287,
		45565
	],
	"node_modules_angular_cdk_fesm2022_observers_mjs-_b1b10": [
		1975,
		42287,
		45565,
		57802
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40550": [
		1975,
		9218,
		10766,
		38324,
		42287,
		45315,
		45565,
		57802,
		72374,
		73986
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90951": [
		45315,
		45565
	],
	"node_modules_angular_cdk_fesm2022_portal_mjs-_b9701": [
		45315,
		45565
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b00": [
		1975,
		9218,
		10766,
		42287,
		45315,
		45565,
		57802,
		70600
	],
	"node_modules_angular_cdk_fesm2022_cdk_mjs-_2fb51": [
		45565
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9340": [
		1975,
		42287,
		45315,
		45565
	],
	"node_modules_angular_common_fesm2022_common_mjs-_b4620": [
		45565
	],
	"node_modules_angular_core_fesm2022_core_mjs": [
		50747,
		1975,
		42287,
		12027
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c0": [
		1975,
		42287,
		45315,
		45565
	],
	"node_modules_angular_material_fesm2022_button_mjs-_52ba1": [
		9218,
		45565,
		39866,
		43984
	],
	"node_modules_angular_material_fesm2022_card_mjs-_17bd1": [
		45565,
		45315,
		43984
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb0": [
		1975,
		9218,
		10766,
		39866,
		42287,
		45315,
		45565,
		57463,
		57802,
		73986
	],
	"node_modules_angular_material_fesm2022_dialog_mjs-_b8751": [
		48934,
		45315,
		45565,
		39866,
		96210,
		57802,
		72374,
		1975,
		42287,
		73986,
		38324,
		43984,
		66897
	],
	"node_modules_angular_material_fesm2022_divider_mjs-_593e1": [
		43984,
		45565,
		57802
	],
	"node_modules_angular_material_fesm2022_expansion_mjs-_0cfc1": [
		53734,
		72374,
		45565,
		43984,
		39866,
		42287,
		73986,
		1975,
		66897,
		70600,
		45315
	],
	"node_modules_angular_material_fesm2022_icon_mjs-_bb191": [
		45565,
		43984,
		45315,
		1975,
		42287,
		81663,
		21194
	],
	"node_modules_angular_material_fesm2022_list_mjs-_3eb01": [
		45565,
		57802,
		9218,
		43984,
		1975,
		89636,
		45315,
		62528,
		39866,
		70600,
		73986,
		93793,
		42287
	],
	"node_modules_angular_material_fesm2022_menu_mjs-_fb4a1": [
		45565,
		39866,
		73986,
		1975,
		42287,
		45315,
		43984,
		72374,
		66897,
		10766,
		48934,
		9218,
		38324
	],
	"node_modules_angular_material_fesm2022_tabs_mjs-_b9231": [
		45565,
		43984,
		72374,
		1975,
		38324,
		9218,
		10766,
		39866,
		73986,
		83440,
		42287,
		89636,
		45315,
		66897
	],
	"node_modules_angular_platform-browser_fesm2022_animations_mjs-_f32a1": [
		45565,
		21194,
		30099,
		45315
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f0": [
		45315,
		45565,
		81663
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a220": [
		1975,
		21194,
		42287,
		45315,
		45565
	],
	"node_modules_apollo_client_core_index_js": [
		38445
	],
	"node_modules_azure_msal-angular_fesm2020_azure-msal-angular_mjs-_6c4a1": [
		45565,
		34953,
		1975,
		45315,
		42287,
		13319
	],
	"node_modules_apollo-angular_fesm2022_ngApollo_mjs-_c9b81": [
		1975,
		45565,
		95517,
		42287
	],
	"node_modules_angular_animations_fesm2022_animations_mjs-_d6a81": [
		45315
	],
	"node_modules_angular_cdk_fesm2022_platform_mjs-_90950": [
		45315
	],
	"node_modules_angular_cdk_fesm2022_observers_mjs-_b1b11": [
		57802
	],
	"node_modules_angular_cdk_fesm2022_a11y_mjs-_ca011": [
		1975,
		9218,
		18606,
		18934,
		42287,
		45315,
		57802,
		73986,
		89636
	],
	"node_modules_angular_cdk_fesm2022_overlay_mjs-_40551": [
		9218,
		10766,
		38324,
		57802
	],
	"node_modules_angular_cdk_fesm2022_scrolling_mjs-_f5b01": [
		9218,
		10766,
		57802,
		70600
	],
	"node_modules_angular_material_fesm2022_core_mjs-_90eb1": [
		1975,
		9218,
		10766,
		39866,
		42287,
		45315,
		57463,
		57802,
		73986
	],
	"node_modules_angular_cdk_fesm2022_dialog_mjs-_76f31": [
		9218,
		10766
	],
	"node_modules_angular_platform-browser_fesm2022_platform-browser_mjs-_e89f1": [
		81663
	],
	"node_modules_angular_common_fesm2022_http_mjs-_f9341": [
		1975,
		42287
	],
	"node_modules_angular_forms_fesm2022_forms_mjs-_0f7c1": [
		42287
	],
	"node_modules_angular_animations_fesm2022_browser_mjs-_2a591": [
		66897
	],
	"node_modules_angular_router_fesm2022_router_mjs-_5a221": [
		21194,
		42287
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}